import axios from "axios";
import config from "environment";

const { baseApi } = config;

export const apiVerifyAdminSecret = async (
  secret: string
): Promise<boolean> => {
  try {
    // Create a separate axios instance without the logout interceptor
    const adminClient = axios.create({
      baseURL: baseApi,
      headers: {
        "Content-Type": "application/json",
      },
    });

    const response = await adminClient.post("/employees/admin/verify", {
      secret,
    });

    return response.data?.data?.verified || false;
  } catch (error) {
    console.error("Error verifying admin secret:", error);
    return false;
  }
};
